import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Commentaire } from '../models/Commentaire';

@Component({
  selector: 'app-commentaire-form',
  imports: [ReactiveFormsModule,MatDialogModule,MatFormFieldModule,MatInputModule,MatButtonModule],
  templateUrl: './commentaire-form.component.html',
  styleUrl: './commentaire-form.component.css',
})
export class CommentaireFormComponent implements OnInit {

  form: any
  commentaire!: Commentaire;


  ngOnInit(): void {
    this.form = this.fb.group({
      texte: ['', Validators.required]
    });

    if (this.commentaire) {
      this.form.patchValue(this.commentaire);
    }
  }

  constructor(
    public dialogRef: MatDialogRef<CommentaireFormComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.commentaire = data.commentaire;
  }

  save() {
    if (this.form.valid) {
      this.commentaire = this.form.value;
      this.commentaire.auteur = localStorage.getItem('username') || ''
      this.dialogRef.close(this.form.value);
    }
  }

}
